import { render, staticRenderFns } from "./CargaPantografo.vue?vue&type=template&id=88b1774e&"
import script from "./CargaPantografo.vue?vue&type=script&lang=js&"
export * from "./CargaPantografo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports